import React from 'react'
import { Typography, makeStyles, Slider } from '@paintscout/ui'
import type { MuiTheme as Theme, SliderProps, StyleClasses } from '@paintscout/ui'
import { BUILDER_V2_INK, BUILDER_V2_MUTED_TEXT } from '../../util'

const useStyles = makeStyles<Theme, SliderOptionProps>(
  (theme) => ({
    root: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      minHeight: 44
    },
    sliderWrapper: {
      flex: '1 1 auto',
      minWidth: 0
    },
    sliderRoot: {
      color: BUILDER_V2_MUTED_TEXT
    },
    label: {
      flexShrink: 0,
      fontSize: '.8125rem',
      fontWeight: 500,
      marginRight: theme.spacing(3),
      color: BUILDER_V2_INK
    }
  }),
  { name: 'SliderOption' }
)

export interface SliderOptionProps {
  classes?: StyleClasses<typeof useStyles>
  marks: SliderProps['marks']
  label: string
  value: number
  min: number
  max: number
  onChange: (value: number) => void
}

function SliderOption(props: SliderOptionProps) {
  const classes = useStyles(props)
  const { marks, label, value, min, max, onChange } = props

  const handleChange: any = (event: React.ChangeEvent<HTMLSpanElement>, value: number) => {
    onChange(value)
  }

  return (
    <div className={classes.root}>
      <Typography className={classes.label} variant={'h5'}>
        {label}
      </Typography>
      <div className={classes.sliderWrapper}>
        <Slider
          onMouseDown={(event) => event.stopPropagation()}
          classes={{ root: classes.sliderRoot }}
          defaultValue={value}
          marks={marks}
          max={max}
          min={min}
          onChange={handleChange}
          step={null}
          track={false}
        />
      </div>
    </div>
  )
}

export default SliderOption
